import { memo } from 'react';
import type { EpcProjectMembershipRow } from '../../../../services/epcProjectService';

interface DepartmentTagStripProps {
  myMembership?: EpcProjectMembershipRow | undefined;
}

/** Friendly label for the membership role + org unit name. */
function labelFor(m: EpcProjectMembershipRow): string {
  const role = m.role.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  const ou = (m as { orgUnit?: { name?: string } | null }).orgUnit?.name;
  return ou ? `${ou} · ${role}` : role;
}

function DepartmentTagStripImpl({ myMembership }: DepartmentTagStripProps) {
  if (!myMembership) return null;
  return (
    <div className="mt-1.5 flex flex-wrap gap-1.5">
      <span
        key={myMembership.id}
        className="inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-[10.5px] font-semibold"
        style={{ background: '#fcfaf3', border: '1px solid rgba(11,59,46,0.22)', color: '#2A1F17' }}
      >
        <span>👷</span>
        {labelFor(myMembership)}
      </span>
    </div>
  );
}

const DepartmentTagStrip = memo(DepartmentTagStripImpl);
export default DepartmentTagStrip;
